import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from './errors/api-error'

// Constants
const EXTERNAL_LAYER_API = getEnv('REACT_APP_EXTERNAL_LAYER_ATTACHMENT', '')

const headers = {
  'Content-Type': 'application/json',
}

// Types
interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

type AttachmentResponseData = any

export type GetAttachment = ApiResponse<AttachmentResponseData>

export const submitAttachmentExternal = async (formData: any): Promise<any> => {
  try {
    const response = await axios.post<any>(
      `${EXTERNAL_LAYER_API}/api/v1/external/attachment/send-complete`,
      formData,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in submitAttachment:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const checkAttachmentRequirementsExternal = async (
  formData: any,
): Promise<any> => {
  try {
    const response = await axios.post<any>(
      `${EXTERNAL_LAYER_API}/api/v1/external/attachment/requirements`,
      formData,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in checkAttachmentRequirements:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}
